import formMainTagsWhiteLabel from './formMainTagsWhiteLabel';

export default {
  title: 'New Tag ',
  attributeName: 'tagmanager',
  getURL: 'tagmanager',
  updateURL: 'appId/appTagsPlay',
  additionaMetadataURL: '',
  removeURL: '',
  canCreate: true,
  idAttribute: 'id',
  sessionParams: [],
  sessionParams: ['appId'],
  formConfig: [formMainTagsWhiteLabel],
  noArea: true,
  goBack: true,
};
